import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import FeaturedStories from './components/FeaturedStories';
import CategoryGrid from './components/CategoryGrid';
import TopRanked from './components/TopRanked';
import CommunityHighlights from './components/CommunityHighlights';
import Footer from '../../components/feature/Footer';
import Navbar from '../../components/feature/Navbar';
import SEOHead from '../../components/feature/SEOHead';

const HomePage = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <SEOHead
        title="Sinister Files – Horror Fiction Community | Dark Stories & Creepypasta"
        description="Sinister Files is the premier horror fiction community. Discover chilling psychological horror, supernatural tales, and cosmic dread written by independent horror authors. Read, write, and share dark stories."
        canonical="https://sinisterfiles.com/"
      />
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <FeaturedStories />
      <CategoryGrid />
      <TopRanked />
      <CommunityHighlights />
      <Footer />
    </div>
  );
};

export default HomePage;
